import React, { useEffect, useMemo, useState } from 'react';
import useDashboardContext from 'contexts/dashboard.context';
import SearchInput from 'components/base/search-input';
import RestaurantCard from 'components/restaurant-card';
import useOrdersContext from 'contexts/orders.context';
import { Bars } from 'react-loader-spinner';
import { useNavigate, useSearchParams } from 'react-router-dom';
import { ROUTE_KEYS } from 'utils/constants';
import { ENUM_ORDERS_TYPE } from 'utils/enum';

import ScheduledDeliveryModal from 'components/modals/scheduled-delivery-modal';
import BusyModal from 'components/modals/busy-modal';
import { getIsBusy } from 'utils/functions';
import { BrandType } from 'models/brand.model';

const BrandsDisplay = () => {
  const navigate = useNavigate();
  const {
    restaurants,
    restaurantsLoading,
    calculatedOrder,
    calculatedOrderForm,
    setcalculatedOrderForm,
    handleReset
  } = useOrdersContext();
  const { setBackLinkTitle, setIsBackLink, setBackLink, setIsBasketDisabled } =
    useDashboardContext();
  const [searchParams] = useSearchParams();
  const [value, setValue] = useState('');
  const [filteredRestaurants, setFilteredRestaurants] = useState(restaurants);

  const [showDeliveryModal, setShowDeliveryModal] = useState(false);
  const [restaurant, setRestaurant] = useState<BrandType>();
  const [showRestaurantIsBusy, setShowRestaurantIsBusy] = useState(false);
  const orderType = useMemo(() => {
    return (searchParams.get('type') as ENUM_ORDERS_TYPE) ?? '';
  }, [searchParams]);

  const openRestaurant = (restaurant: BrandType, orderType: ENUM_ORDERS_TYPE) => {
    const restaurantIsBusy = getIsBusy(restaurant);
    if (restaurantIsBusy) {
      setRestaurant(restaurant);
      return setShowRestaurantIsBusy(true);
    }
    navigate(`/orders/restaurants/${restaurant.id}?type=${orderType}`);
  };
  useEffect(() => {
    setIsBackLink(true);
    setIsBasketDisabled(false);
    setBackLinkTitle('Return to Previous');
    setBackLink(`/${ROUTE_KEYS.ORDERS}`);
    if (!orderType || ![ENUM_ORDERS_TYPE.GROUP, ENUM_ORDERS_TYPE.BULK].includes(orderType)) {
      handleReset();
      navigate(`/${ROUTE_KEYS.ORDERS}`);
    } else if (
      orderType === ENUM_ORDERS_TYPE.GROUP &&
      (calculatedOrder?.address_details?.address_line === '' || !calculatedOrder?.address_details)
    )
      return () => {
        setIsBackLink(false);
        setBackLinkTitle('');
        setBackLink('');
      };
  }, []);

  useEffect(() => {
    if (value !== '') {
      const filtered = restaurants.filter((r) =>
        r.name.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredRestaurants(filtered);
    } else {
      setFilteredRestaurants(restaurants);
    }
  }, [value, restaurants]);

  return (
    <div>
      <div className='flex justify-between mt-5 gap-4 '>
        <div>
          <h1 className='text-[20px] font-bold'>Restaurants</h1>
          <p className='whitespace-nowrap text-xs mt-1 text-[#6F7376]'>
            Select your preferred restaurant
          </p>
        </div>
        <div>
          <SearchInput
            placeholder='search'
            value={value}
            handleChange={(e) => setValue(e.target.value)}
          />
        </div>
      </div>

      {restaurantsLoading ? (
        <div className='grow w-full h-screen flex justify-center pt-[25vh]'>
          <Bars color='#E60A2B' height={50} width={50} />
        </div>
      ) : !restaurantsLoading && filteredRestaurants?.length === 0 ? (
        <div className='w-full h-[40vh] flex justify-center items-center'>
          <p className='text-gray-9 text-center w-full'>No restaurants found</p>
        </div>
      ) : (
        <div className='w-full mx-auto flex flex-col gap-8 py-10'>
          <div className='w-full grid grid-cols-[repeat(auto-fill,_minmax(250px,_1fr))] gap-5'>
            {filteredRestaurants.map((restaurant: any) => (
              <RestaurantCard
                key={restaurant.id}
                restaurant={restaurant}
                orderCount={restaurant.orderCount}
                orderType={orderType}
                onOpen={openRestaurant}
              />
            ))}
          </div>
        </div>
      )}

      <ScheduledDeliveryModal
        handleClick={(k) => {
          setcalculatedOrderForm({ ...calculatedOrderForm, ...k });
          setShowDeliveryModal(false);
        }}
        isOpen={showDeliveryModal}
        onClose={() => setShowDeliveryModal(false)}
        type='group'
      />
      {restaurant ? (
        <BusyModal
          open={showRestaurantIsBusy}
          onClose={() => setShowRestaurantIsBusy(false)}
          data={restaurant}
        />
      ) : null}
    </div>
  );
};

export default BrandsDisplay;
